<script setup>
  import { ref, onBeforeUnmount, onUnmounted, nextTick, watchEffect } from 'vue'
  import { useFocusTrap } from '@vueuse/integrations/useFocusTrap';  
  import CloseButton from '../CloseButton.vue';

  // TODO: Add click out side to close
  const props = defineProps({
    allowOutsideClick: {
      type: Boolean,
      default: true
    },
    hideCloseButton: {
      type: Boolean,
      default: false
    },
    height: {
      type: String,
      default: 'auto'
    }
  });

  const model = defineModel();

  let modal = ref(null);
  let showModal = ref(false);

  const { activate, deactivate } = useFocusTrap(modal, { allowOutsideClick: handleCloseModal, returnFocusOnDeactivate: false })

  async function activateFocusTrap() {
    await nextTick();
    activate();
  }

  function handleCloseModal(e) {
    model.value = false;
    deactivate()
  }

  onBeforeUnmount(() => deactivate())

  watchEffect(() => {
    showModal.value = model.value;
    activateFocusTrap()
  })
</script>

<template>
  <Teleport to="body">
    <Transition name="show-modal">
      <div v-if="showModal" class="jwx-modal-backdrop">
        <div ref="modal" class="jwx-modal" :class="{'jwx-modal--tall': props.height === 'tall'}">
          <div class="jwx-modal__content">
            <CloseButton v-if="!hideCloseButton" @click.prevent="handleCloseModal" class="jwx-modal__close-button" />
  
            <slot></slot>
          </div>
        </div>
      </div>
    </Transition>
  </Teleport>
</template>